module.exports = __webpack_public_path__ + "e7c0ddbf4605fa96030b85d8d82d06e4.woff";